import React, { Component } from 'react';

import TaskDoctor from './TaskDoctor';
import WbsLayout from '../../../components/WbsLayout/';

export default class GanttWrapper extends Component {
  render() {
    return (
      <WbsLayout>
        <TaskDoctor {...this.props} />
      </WbsLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Project/TaskDoctor/TaskDoctorContainer.js